import rank1 from '../../../../assets/games/rankNumbers/rank_1.svg?url';
import rank10 from '../../../../assets/games/rankNumbers/rank_10.svg?url';
import rank11 from '../../../../assets/games/rankNumbers/rank_11.svg?url';
import rank12 from '../../../../assets/games/rankNumbers/rank_12.svg?url';
import rank13 from '../../../../assets/games/rankNumbers/rank_13.svg?url';
import rank14 from '../../../../assets/games/rankNumbers/rank_14.svg?url';
import rank15 from '../../../../assets/games/rankNumbers/rank_15.svg?url';
import rank16 from '../../../../assets/games/rankNumbers/rank_16.svg?url';
import rank17 from '../../../../assets/games/rankNumbers/rank_17.svg?url';
import rank18 from '../../../../assets/games/rankNumbers/rank_18.svg?url';
import rank19 from '../../../../assets/games/rankNumbers/rank_19.svg?url';
import rank2 from '../../../../assets/games/rankNumbers/rank_2.svg?url';
import rank20 from '../../../../assets/games/rankNumbers/rank_20.svg?url';
import rank3 from '../../../../assets/games/rankNumbers/rank_3.svg?url';
import rank4 from '../../../../assets/games/rankNumbers/rank_4.svg?url';
import rank5 from '../../../../assets/games/rankNumbers/rank_5.svg?url';
import rank6 from '../../../../assets/games/rankNumbers/rank_6.svg?url';
import rank7 from '../../../../assets/games/rankNumbers/rank_7.svg?url';
import rank8 from '../../../../assets/games/rankNumbers/rank_8.svg?url';
import rank9 from '../../../../assets/games/rankNumbers/rank_9.svg?url';

// Imported as URLs, not `?raw`: inlining the SVG source put 1.2MB of markup into the entry
// chunk. As separate assets the browser fetches them only when the carousel renders.
export const RANK_SVGS: Record<number, string> = {
  1: rank1,
  2: rank2,
  3: rank3,
  4: rank4,
  5: rank5,
  6: rank6,
  7: rank7,
  8: rank8,
  9: rank9,
  10: rank10,
  11: rank11,
  12: rank12,
  13: rank13,
  14: rank14,
  15: rank15,
  16: rank16,
  17: rank17,
  18: rank18,
  19: rank19,
  20: rank20,
};
